import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { User } from "../models/user";

type ContactPageProps = {
  user: User | null;
};

const ContactPage: React.FC<ContactPageProps> = ({ user }) => {
  const handleContactClick = () => {
    window.location.href =
      "mailto:contactmagellanmaps@gmail.com?subject=Contacting Magellan Maps";
  };

  return (
    <Box
      minHeight="75vh"
      py={6}
      px={{ xs: 2, md: 6 }}
      bgcolor="#f9f9f9"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
    >
      <Typography variant="h3" fontWeight={700} gutterBottom>
        Get In Touch
      </Typography>

      <Typography
        variant="h6"
        color="textSecondary"
        maxWidth="600px"
        gutterBottom
      >
        {user?.username
          ? `Hi ${user.username}, if you’ve got questions or feedback, we’re all ears.`
          : "Whether you’ve got questions, feedback, or ideas, we’d love to hear from you."}{" "}
        Reach out to the team behind Magellan Maps and let’s make something
        amazing together.
      </Typography>

      <Button
        variant="contained"
        color="primary"
        style={{
          backgroundColor: "black",
          borderColor: "white",
          outlineColor: "white",
        }}
        size="large"
        onClick={handleContactClick}
        sx={{ mt: 4, px: 5, py: 1.5 }}
      >
        Contact Us
      </Button>
    </Box>
  );
};

export default ContactPage;
